export default [
  { to: '/crawl/cars', display: 'Car items' },
  { to: '/crawl/wikiboxes', display: 'Wiki Infoboxes' },
  { to: '/crawl/usertrims', display: 'Users Trims' },
  // { to: '/crawl/models', display: 'Models' },
];
